<agpr-panel
    header="PageBuilder.blockType.charts"
>
    <div class="agpr-chartField-addChart">
        <agpr-button
            [label]="block?.canAddChart ? 'PageBuilder.blockType.chart.addChart' : 'PageBuilder.blockType.chart.editChart'"
            [style]="buttonTypes.secondary"
            [icon]="'fa-pie-chart fa-duotone fa-regular'"
            (click)="openChartDialog()"
        ></agpr-button>
    </div>
    @if (block?.canEditChart) {
        <div class="agpr-chartField-generateOption">
            <div class="agpr-chartField-fieldRow">
                <agpr-radio
                    label="PageBuilder.blockType.chart.generateNow"
                    [tooltip]="'PageBuilder.blockType.chart.generateNow.tooltip'"
                    hiddenLabel="PageBuilder.blockType.chart.generateNow"
                    [(ngModel)]="value.generateOnSend"
                    (ngModelChange)="generationMethodChanged($event)"
                    [value]="false"
                ></agpr-radio>
                <agpr-button
                    [style]="buttonTypes.icon"
                    icon="fa fa-refresh"
                    tooltip="PageBuilder.blockType.chart.refreshChartData"
                    tooltipPosition="top"
                    (click)="refreshData()"
                ></agpr-button>
            </div>
            <agpr-radio
                label="PageBuilder.blockType.chart.generateOnSend"
                [tooltip]="'PageBuilder.blockType.chart.generateOnSend.tooltip'"
                hiddenLabel="PageBuilder.blockType.chart.generateOnSend"
                [(ngModel)]="value.generateOnSend"
                (ngModelChange)="generationMethodChanged($event)"
                [value]="true"
            ></agpr-radio>
        </div>
    }
    @if (resourceDeleted) {
        <agpr-message
            class="agpr-chartField-noData"
            [severity]="messageSeverities.warning"
        >
            {{ 'PageBuilder.blockType.chart.noDataSource.message'| localize }}
            <agpr-button
                class="agpr-chartField-noDataButton"
                [style]="buttonTypes.link"
                (click)="openChartDialog()"
            >
                {{ 'PageBuilder.blockType.chart.noDataSource.action' | localize }}
            </agpr-button>
        </agpr-message>
    }
</agpr-panel>
@if (block?.canEditChart) {
    <div class="agpr-blockForm">
        <ng-template #formFieldsContainer></ng-template>
    </div>
}
